<template>
  <div class="vip-ad" @click="handlerJumpVipPage">
    <div class="vip-ad--text">成为有讲会员，尊享<strong>3</strong>大权益</div>
    <div class="vip-ad__btn">了解详情<van-icon name="arrow" size="12" /></div>
  </div>
</template>

<script>
import { Icon } from 'vant';

export default {
  components: {
    [Icon.name]: Icon
  },
  setup() {
    /**
     * @description 进入会员中心
     */
    const handlerJumpVipPage = () => {
      window.location.href = `${window.location.origin}/lesson/buy_vip?_source=user_center`;
    };

    return {
      handlerJumpVipPage
    };
  }
};
</script>

<style lang="stylus" scoped>
.vip-ad {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 4% 14px 4%;
  height: 69px;
  background: url('../../assets/myself/my_ad_bg.png');
  background-size: 100% 100%;

  .vip-ad--text {
    margin-bottom: 2px;
    padding-left: 11%;
    font-size: 13px;
    font-weight: 500;
    color: #76452E;

    strong {
      margin: 0 2px;
      font-size: 20px;
    }
  }

  .vip-ad__btn {
    display: flex;
    align-items: center;
    padding-left: 32px;
    width: 112px;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: url('../../assets/myself/myself_ad_bg_gray.png');
    background-size: cover;
  }
}
</style>
